import { useState, useEffect } from "react";
import Axios from "axios";
import { useBaseUrl } from "../ApiContext";

const useSessions = (userToken, date, setIsLoading) => {
  const baseUrl = useBaseUrl();
  const [sessions, setSessions] = useState([]);

  useEffect(() => {
    const fetchSessions = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/main_page/session/${date}`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        setSessions(response.data.sessions);
        setIsLoading(false);
      } catch (error) {
        console.log("Error during getting sessions", error);
      }
    };
    if (userToken) {
      fetchSessions();
    }
  }, [baseUrl, userToken, date]);
  return { sessions };
};

export default useSessions;
